import { render } from "./AddCreditPage.vue?vue&type=template&id=5db377d8&scoped=true"
import script from "./AddCreditPage.vue?vue&type=script&lang=js"
export * from "./AddCreditPage.vue?vue&type=script&lang=js"

import "./AddCreditPage.vue?vue&type=style&index=0&id=5db377d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db377d8"]])

export default __exports__